<template>
  <v-row >
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
small
            color="primary"
            dark
            fab
            v-bind="attrs"
            v-on="on"        >
          <v-icon dark>
            mdi-information
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>                            Тарифный калькулятор расчета стоимости потребленной электроэнергии.
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
       <v-card-text>
         <br>
         При выборе тарифа на электроэнергию наиболее сложной задачей для потребителя обычно является сравнение тарифов, по которым производится учет электроэнергии и сравнение их между собой, поскольку они рассчитываются по разным методикам.<br><br>
         Данный тарифный калькулятор имеет функционал, позволяющий предприятиям и организациям оптимизировать затраты на электроэнергию посредством анализа почасового потребления и подбора наиболее выгодного тарифа, исходя из представленных почасовых данных, рассчитать конечную стоимости по договору электроснабжения в зависимости от выбранного тарифа (ценовой категории) и экономить за счет перехода на более выгодный тариф для снижения издержек производственно-хозяйственной деятельности.<br><br>
         Калькулятор предлагает расчет и сравнение стоимости для 1, 3 и 4 ценовой категории, не рассматривая 2ю ЦК, так как она выгодна для предприятий с ночным режимом работы, а также 5ю и 6ю ЦК, так как использование данных ценовых категорий предусматривает планирование почасовых объемов потребления электроэнергии на месяц по каждому часу и предоставления этих данных поставщику.<br>
         Для расчета наиболее выгодного тарифа на электроэнергию (выбора ценовой категории) необходимо ввести следующие данные:<br><br>
         <ul>
           <li>
             субъект РФ, где расположен потребитель электроэнергии

           </li>
           <li>         диапазон мощности (первая группа - от 10МВт, вторая группа - от 670кВт до 10МВт, третья группа - до 670 кВ, при этом необходимо учитывать, что предприятиям, входящим в первую и вторую группу возможен учет только с 3 по 6 ЦК)
           </li>
           <li>
             - уровень напряжения (ВН – присоединение на сетях 110кВ и выше, СН1 – присоединение на сетях от 35кВ, но не более 110кВ, СН2 – присоединение на сетях от 1кВ, но не более 35кВ, НН – присоединение на сетях до 1кВ.

           </li>
           <li>         - почасовые данные учета потребленной электроэнергии за месяц (профиль мощности)
           </li>
         </ul><br>
         На основании этих данных тарифный калькулятор произведет расчет стоимости электроэнергии за месяц по 1, 3 и 4 ценовой категории и позволит выбрать наиболее подходящий и экономичный тариф для предприятия.<br>

         <a href="https://ээ-калькулятор.рф">https://ээ-калькулятор.рф.</a>
       </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: 'ModalInfo',
  data () {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    }
  },
}
</script>
